<shabic-dialog class="block h-full">
  <iframe #iframe src="" class="hidden"></iframe>
  <img #image src="" class="hidden" />
</shabic-dialog>
